import { SvgIcon } from "@mui/material";

export const RotateIcon = ({ color = "#13130C" }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10 3.25C8.66498 3.25 7.35994 3.64588 6.24991 4.38758C5.13987 5.12928 4.27471 6.18349 3.76382 7.41689C3.25293 8.65029 3.11925 10.0075 3.3797 11.3169C3.64015 12.6262 4.28303 13.829 5.22703 14.773C6.17104 15.717 7.37377 16.3599 8.68315 16.6203C9.99252 16.8808 11.3497 16.7471 12.5831 16.2362C13.8165 15.7253 14.8707 14.8601 15.6124 13.7501C16.3541 12.6401 16.75 11.335 16.75 10H18.25C18.25 11.6317 17.7661 13.2267 16.8596 14.5835C15.9531 15.9402 14.6646 16.9976 13.1571 17.622C11.6497 18.2464 9.99085 18.4098 8.39051 18.0915C6.79017 17.7732 5.32016 16.9874 4.16637 15.8336C3.01259 14.6798 2.22685 13.2098 1.90853 11.6095C1.5902 10.0092 1.75357 8.35035 2.378 6.84286C3.00242 5.33537 4.05984 4.0469 5.41655 3.14038C6.77326 2.23385 8.36831 1.75 10 1.75C12.2993 1.75 14.4925 2.66224 16.1364 4.24265L16.1418 4.24778L16.75 4.85602L16.75 2.49999L18.25 2.50001L18.25 7.41667H13.3334V5.91667H15.6893L15.0917 5.31902C13.7196 4.00252 11.8983 3.25 10 3.25Z"
      fill={color}
    />
  </svg>
);

export const MoveIcon = ({ color = "#13130C" }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
  >
    <g clipPath="url(#clip0_808_2478)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.0001 0.939331L13.0304 3.96966L11.9698 5.03032L10.7501 3.81065V9.24999H16.1895L14.9698 8.03032L16.0304 6.96966L19.0608 9.99999L16.0304 13.0303L14.9698 11.9697L16.1895 10.75H10.7501V16.1893L11.9698 14.9697L13.0304 16.0303L10.0001 19.0606L6.96978 16.0303L8.03044 14.9697L9.25011 16.1893V10.75H3.81077L5.03044 11.9697L3.96978 13.0303L0.939453 9.99999L3.96978 6.96966L5.03044 8.03032L3.81077 9.24999H9.25011V3.81065L8.03044 5.03032L6.96978 3.96966L10.0001 0.939331Z"
        fill={color}
      />
    </g>
    <defs>
      <clipPath id="clip0_808_2478">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const TranslateYIcon = ({ color = "#13130C" }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.0001 0.939331L13.0304 3.96966L11.9697 5.03032L10.7501 3.81065V16.1893L11.9697 14.9697L13.0304 16.0303L10.0001 19.0606L6.96973 16.0303L8.03039 14.9697L9.25006 16.1893V3.81065L8.03039 5.03032L6.96973 3.96966L10.0001 0.939331Z"
      fill={color}
    />
  </svg>
);

export const PlayIcon = ({ color = "#13130C" }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.25 1.63376L17.397 10L4.25 18.3663V1.63376ZM5.75 4.36627V15.6338L14.603 10L5.75 4.36627Z"
      fill={color}
    />
  </svg>
);

// { color = "#13130C" }
export const CloseIcon = props => (
  <SvgIcon
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 20 20"
    fill="none"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.93842 10.0001L1.46875 2.53039L2.52941 1.46973L9.99908 8.9394L17.4687 1.46973L18.5294 2.53039L11.0597 10.0001L18.5294 17.4697L17.4687 18.5304L9.99908 11.0607L2.52941 18.5304L1.46875 17.4697L8.93842 10.0001Z"
      fill="currentColor"
    />
  </SvgIcon>
);

export const ChevronDIcon = props => (
  <svg
    {...props}
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.0001 12.9394L2.53039 5.46973L1.46973 6.53039L10.0001 15.0607L18.5304 6.53039L17.4697 5.46973L10.0001 12.9394Z"
      fill="#13130C"
    />
  </svg>
);

export const BuildMinervaIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
  >
    <g clipPath="url(#clip0_475_4764)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10 1.75C9.84591 1.75 9.69287 1.75422 9.54101 1.76253C9.12741 1.78518 8.77377 1.46825 8.75112 1.05466C8.72847 0.641067 9.0454 0.287423 9.45899 0.264776C9.63816 0.254965 9.81854 0.25 10 0.25C10.1815 0.25 10.3618 0.254966 10.541 0.264776C10.9546 0.287423 11.2715 0.641067 11.2489 1.05466C11.2262 1.46826 10.8726 1.78518 10.459 1.76253C10.3071 1.75422 10.1541 1.75 10 1.75ZM13.3911 1.62867C13.5783 1.25916 14.0296 1.11136 14.3991 1.29855C14.5592 1.37963 14.7178 1.46552 14.875 1.55625C15.0322 1.64698 15.1859 1.74147 15.3361 1.83955C15.683 2.06596 15.7806 2.53069 15.5542 2.87755C15.3278 3.22441 14.8631 3.32205 14.5162 3.09564C14.3889 3.01251 14.2584 2.93234 14.125 2.85529C13.9915 2.77824 13.8569 2.70538 13.7212 2.63665C13.3517 2.44946 13.2039 1.99818 13.3911 1.62867ZM6.60885 1.62871C6.79603 1.99822 6.64823 2.4495 6.27872 2.63669C6.14305 2.70542 6.00841 2.77828 5.87496 2.85533C5.74151 2.93238 5.61109 3.01254 5.48373 3.09568C5.13687 3.32209 4.67214 3.22445 4.44573 2.87759C4.21932 2.53073 4.31696 2.066 4.66382 1.83959C4.81408 1.74151 4.96781 1.64702 5.12496 1.55629C5.28211 1.46556 5.44081 1.37967 5.60088 1.29858C5.97038 1.1114 6.42167 1.2592 6.60885 1.62871ZM2.87755 4.44577C3.22441 4.67218 3.32205 5.13691 3.09564 5.48377C3.0125 5.61113 2.93234 5.74155 2.85529 5.875C2.77824 6.00845 2.70538 6.14309 2.63665 6.27876C2.44947 6.64827 1.99818 6.79607 1.62867 6.60889C1.25916 6.42171 1.11136 5.97042 1.29854 5.60092C1.37963 5.44085 1.46552 5.28215 1.55625 5.125C1.64698 4.96785 1.74147 4.81412 1.83955 4.66386C2.06596 4.317 2.53069 4.21936 2.87755 4.44577ZM17.1224 4.44581C17.4693 4.2194 17.934 4.31704 18.1604 4.6639C18.2585 4.81415 18.353 4.96788 18.4437 5.12504C18.5344 5.28219 18.6203 5.44089 18.7014 5.60095C18.8886 5.97046 18.7408 6.42175 18.3713 6.60893C18.0018 6.79611 17.5505 6.64831 17.3633 6.2788C17.2946 6.14312 17.2217 6.00849 17.1447 5.87504C17.0676 5.74159 16.9875 5.61117 16.9043 5.4838C16.6779 5.13695 16.7756 4.67222 17.1224 4.44581ZM6.25 6.25H13.75V13.75H6.25V6.25ZM7.75 7.75V12.25H12.25V7.75H7.75ZM1.05466 8.75112C1.46826 8.77377 1.78518 9.12742 1.76253 9.54101C1.75422 9.69287 1.75 9.84591 1.75 10C1.75 10.1541 1.75422 10.3071 1.76253 10.459C1.78518 10.8726 1.46826 11.2262 1.05466 11.2489C0.64107 11.2715 0.287425 10.9546 0.264777 10.541C0.254965 10.3618 0.25 10.1815 0.25 10C0.25 9.81854 0.254966 9.63816 0.264777 9.45899C0.287425 9.0454 0.64107 8.72847 1.05466 8.75112ZM18.9453 8.75112C19.3589 8.72847 19.7126 9.0454 19.7352 9.45899C19.745 9.63816 19.75 9.81854 19.75 10C19.75 10.1815 19.745 10.3618 19.7352 10.541C19.7126 10.9546 19.3589 11.2715 18.9453 11.2489C18.5317 11.2262 18.2148 10.8726 18.2375 10.459C18.2458 10.3071 18.25 10.1541 18.25 10C18.25 9.84591 18.2458 9.69287 18.2375 9.54101C18.2148 9.12742 18.5317 8.77377 18.9453 8.75112ZM18.3713 13.3911C18.7408 13.5783 18.8886 14.0296 18.7015 14.3991C18.6204 14.5592 18.5345 14.7178 18.4437 14.875C18.353 15.0322 18.2585 15.1859 18.1604 15.3361C17.934 15.683 17.4693 15.7806 17.1224 15.5542C16.7756 15.3278 16.6779 14.8631 16.9044 14.5162C16.9875 14.3889 17.0677 14.2584 17.1447 14.125C17.2218 13.9915 17.2946 13.8569 17.3633 13.7212C17.5505 13.3517 18.0018 13.2039 18.3713 13.3911ZM1.62863 13.3911C1.99814 13.204 2.44943 13.3518 2.63661 13.7213C2.70534 13.857 2.7782 13.9916 2.85525 14.125C2.9323 14.2585 3.01247 14.3889 3.0956 14.5163C3.32201 14.8631 3.22437 15.3279 2.87751 15.5543C2.53065 15.7807 2.06593 15.683 1.83951 15.3362C1.74144 15.1859 1.64694 15.0322 1.55621 14.875C1.46548 14.7179 1.37959 14.5592 1.29851 14.3991C1.11132 14.0296 1.25913 13.5783 1.62863 13.3911ZM4.44577 17.1224C4.67218 16.7756 5.13691 16.678 5.48377 16.9044C5.61112 16.9875 5.74154 17.0677 5.875 17.1447C6.00845 17.2218 6.14309 17.2946 6.27876 17.3634C6.64827 17.5505 6.79607 18.0018 6.60889 18.3713C6.42171 18.7408 5.97042 18.8886 5.60091 18.7015C5.44084 18.6204 5.28215 18.5345 5.125 18.4437C4.96785 18.353 4.81412 18.2585 4.66386 18.1604C4.317 17.934 4.21936 17.4693 4.44577 17.1224ZM15.5542 17.1225C15.7806 17.4693 15.683 17.9341 15.3361 18.1605C15.1858 18.2586 15.0321 18.3531 14.875 18.4438C14.7178 18.5345 14.5591 18.6204 14.399 18.7015C14.0295 18.8887 13.5783 18.7409 13.3911 18.3714C13.2039 18.0019 13.3517 17.5506 13.7212 17.3634C13.8569 17.2947 13.9915 17.2218 14.125 17.1447C14.2584 17.0677 14.3888 16.9875 14.5162 16.9044C14.8631 16.678 15.3278 16.7756 15.5542 17.1225ZM8.75112 18.9453C8.77377 18.5317 9.12742 18.2148 9.54101 18.2375C9.69287 18.2458 9.84591 18.25 10 18.25C10.1541 18.25 10.3071 18.2458 10.459 18.2375C10.8726 18.2148 11.2262 18.5317 11.2489 18.9453C11.2715 19.3589 10.9546 19.7126 10.541 19.7352C10.3618 19.745 10.1815 19.75 10 19.75C9.81854 19.75 9.63816 19.745 9.45899 19.7352C9.0454 19.7126 8.72847 19.3589 8.75112 18.9453Z"
        fill="#13130C"
      />
    </g>
    <defs>
      <clipPath id="clip0_475_4764">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const ArrowRightIcon = props => (
  <SvgIcon
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 20 20"
    fill="none"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.947 2.38632L18.5607 9.99999L10.947 17.6136L9.88634 16.553L15.6893 10.75H2.5V9.24999H15.6893L9.88634 3.44698L10.947 2.38632Z"
      fill="currentColor"
    />
  </SvgIcon>
);

export const ArrowLeftIcon = ({ color = "#13130C" }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.31077 10.75L10.1138 16.553L9.05312 17.6137L1.43945 10L9.05312 2.38635L10.1138 3.44701L4.31077 9.25002H17.5001V10.75H4.31077Z"
      fill={color}
    />
  </svg>
);

export const CheckMarkIcon = ({ color = "white" }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.71929 8.30529C6.62704 8.20978 6.5167 8.1336 6.39469 8.08119C6.27269 8.02878 6.14147 8.00119 6.00869 8.00004C5.87591 7.99888 5.74423 8.02419 5.62133 8.07447C5.49844 8.12475 5.38679 8.199 5.29289 8.29289C5.199 8.38679 5.12475 8.49844 5.07447 8.62133C5.02419 8.74423 4.99888 8.87591 5.00004 9.00869C5.00119 9.14147 5.02878 9.27269 5.08119 9.39469C5.1336 9.5167 5.20978 9.62704 5.30529 9.71929L7.30529 11.7193C7.49282 11.9068 7.74712 12.0121 8.01229 12.0121C8.27745 12.0121 8.53176 11.9068 8.71929 11.7193L12.7193 7.71929C12.8148 7.62704 12.891 7.5167 12.9434 7.39469C12.9958 7.27269 13.0234 7.14147 13.0245 7.00869C13.0257 6.87591 13.0004 6.74423 12.9501 6.62133C12.8998 6.49844 12.8256 6.38679 12.7317 6.29289C12.6378 6.199 12.5261 6.12475 12.4032 6.07447C12.2803 6.02419 12.1487 5.99888 12.0159 6.00004C11.8831 6.00119 11.7519 6.02878 11.6299 6.08119C11.5079 6.1336 11.3975 6.20978 11.3053 6.30529L8.01229 9.59829L6.71929 8.30529Z"
      fill={color}
    />
  </svg>
);

export const TooltipIcon = ({ color = "#A5A59F" }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10 18C14.4183 18 18 14.4183 18 10C18 5.58172 14.4183 2 10 2C5.58172 2 2 5.58172 2 10C2 14.4183 5.58172 18 10 18ZM10.5936 7.53121C11.2926 7.53121 11.8592 6.96458 11.8592 6.2656C11.8592 5.56663 11.2926 5 10.5936 5C9.89467 5 9.32804 5.56663 9.32804 6.2656C9.32804 6.96458 9.89467 7.53121 10.5936 7.53121ZM9.66366 15C10.437 15 11.0331 14.7688 11.6245 14.249C11.6245 14.249 10.1343 14.639 10.1343 13.4461C10.1343 12.8064 10.3431 12.1955 10.5521 11.5842C10.7614 10.9719 10.9709 10.3593 10.9709 9.71685C10.9709 8.84107 10.1798 8.42196 9.40222 8.42196C8.37036 8.42196 7.44141 9.22479 7.44141 9.22479C7.44141 9.22479 8.87934 9.21282 8.87934 9.97583C8.87934 10.6153 8.67043 11.2266 8.4614 11.8382C8.25212 12.4506 8.04272 13.0633 8.04272 13.7051C8.04272 14.6006 8.87722 15 9.66366 15Z"
      fill={color}
    />
  </svg>
);

export const PlusIcon = props => (
  <SvgIcon
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.25 9.54028V2.29028H10.75V9.54028H18V11.0403H10.75V18.2903H9.25V11.0403H2V9.54028H9.25Z"
      fill="currentColor"
    />
  </SvgIcon>
);

export const MinusIcon = props => (
  <SvgIcon
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 20 20"
    fill="none"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M18 10.75H2V9.25H18V10.75Z"
      fill="currentColor"
    />
  </SvgIcon>
);

export const CollapseArrowUp = ({ color = "#13130C" }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.99908 7.59092L2.52941 15.0606L1.46875 13.9999L9.99908 5.4696L18.5294 13.9999L17.4687 15.0606L9.99908 7.59092Z"
      fill={color}
    />
  </svg>
);

export const CollapseArrowDown = ({ color = "#13130C" }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.99908 13.2297L2.52941 5.76001L1.46875 6.82067L9.99908 15.351L18.5294 6.82067L17.4687 5.76001L9.99908 13.2297Z"
      fill={color}
    />
  </svg>
);

export const DeleteIcon = ({ color = "#696960" }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.5625 4.83053V3.91386C13.5625 3.27292 13.3079 2.65823 12.8547 2.20502C12.4015 1.7518 11.7868 1.49719 11.1458 1.49719H8.85417C8.21323 1.49719 7.59854 1.7518 7.14533 2.20502C6.69211 2.65823 6.4375 3.27292 6.4375 3.91386V4.83053H2.5V6.33053H17.5V4.83053H13.5625ZM8.85417 2.99719C8.61105 2.99719 8.37789 3.09377 8.20599 3.26568C8.03408 3.43759 7.9375 3.67074 7.9375 3.91386V4.83053H12.0625V3.91386C12.0625 3.67074 11.9659 3.43759 11.794 3.26568C11.6221 3.09377 11.3889 2.99719 11.1458 2.99719H8.85417Z"
      fill={color}
    />
    <path
      d="M6.04794 17.9492C5.8828 17.8106 5.7718 17.618 5.7345 17.4056L4.072 7.95064L2.59467 8.21041L4.25714 17.6653C4.3555 18.2251 4.64809 18.7325 5.08343 19.098C5.51878 19.4635 6.06905 19.6639 6.6375 19.6639H13.3625C13.9309 19.6639 14.4812 19.4635 14.9166 19.098C15.3519 18.7325 15.6445 18.2251 15.7429 17.6653L17.4053 8.21041L15.928 7.95064L14.2655 17.4058C14.2282 17.6182 14.1172 17.8106 13.9521 17.9492C13.7869 18.0879 13.5781 18.1639 13.3625 18.1639H12.1728H6.63744C6.42182 18.1639 6.21308 18.0879 6.04794 17.9492Z"
      fill={color}
    />
  </svg>
);

export const LocationIcon = ({ color = "#13130C" }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.72114 11.817C4.37547 12.9792 5.23807 14.1513 6.08556 15.1885C7.29627 16.6703 8.61277 18.0522 9.99967 19.3667C11.3866 18.0522 12.703 16.6704 13.9138 15.1885C14.7613 14.1513 15.6239 12.9792 16.2782 11.817C16.9212 10.6749 17.4163 9.45103 17.4163 8.33333C17.4163 6.36631 16.6349 4.47985 15.244 3.08896C13.8532 1.69806 11.9667 0.916664 9.99967 0.916664C8.03265 0.916664 6.14619 1.69806 4.7553 3.08896C3.3644 4.47985 2.58301 6.36631 2.58301 8.33333C2.58301 9.45103 3.07813 10.6749 3.72114 11.817ZM9.99967 2.41666C8.43048 2.41666 6.92555 3.04003 5.81596 4.14962C4.70637 5.25921 4.08301 6.76413 4.08301 8.33333C4.08301 9.05647 4.42122 10.003 5.02821 11.0811C5.62388 12.1391 6.42794 13.2368 7.24712 14.2394C8.06399 15.2392 8.88288 16.1285 9.49858 16.7687C9.68699 16.9646 9.85601 17.1368 9.99967 17.2813C10.1433 17.1368 10.3124 16.9646 10.5008 16.7687C11.1165 16.1285 11.9354 15.2392 12.7522 14.2394C13.5714 13.2368 14.3755 12.1391 14.9711 11.0811C15.5781 10.003 15.9163 9.05647 15.9163 8.33333C15.9163 6.76413 15.293 5.25921 14.1834 4.14962C13.0738 3.04003 11.5689 2.41666 9.99967 2.41666Z"
      fill={color}
    />
    <path
      d="M9.99967 6.75C9.57975 6.75 9.17702 6.91681 8.88009 7.21375C8.58316 7.51068 8.41634 7.9134 8.41634 8.33333C8.41634 8.75326 8.58316 9.15598 8.88009 9.45292C9.17702 9.74985 9.57975 9.91666 9.99967 9.91666C10.4196 9.91666 10.8223 9.74985 11.1193 9.45292C11.4162 9.15598 11.583 8.75326 11.583 8.33333C11.583 7.9134 11.4162 7.51068 11.1193 7.21375C10.8223 6.91681 10.4196 6.75 9.99967 6.75Z"
      fill={color}
    />
  </svg>
);

export const CheckFacilityIcon = props => (
  <SvgIcon
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 20 20"
    fill="none"
    {...props}
  >
    <path
      d="M10.1248 5.16659C9.70491 5.16659 9.30218 5.3334 9.00525 5.63033C8.70832 5.92727 8.5415 6.32999 8.5415 6.74992C8.5415 7.16985 8.70832 7.57257 9.00525 7.8695C9.30218 8.16644 9.70491 8.33325 10.1248 8.33325C10.5448 8.33325 10.9475 8.16644 11.2444 7.8695C11.5414 7.57257 11.7082 7.16985 11.7082 6.74992C11.7082 6.32999 11.5414 5.92727 11.2444 5.63033C10.9475 5.3334 10.5448 5.16659 10.1248 5.16659Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.375 6.75C4.375 3.47988 6.95758 1 10.125 1C13.2924 1 15.875 3.47988 15.875 6.75C15.875 8.66656 14.9504 10.5193 13.9197 12H16.125L19.25 19.5H1L4.125 12H6.33027C5.29955 10.5193 4.375 8.66656 4.375 6.75ZM10.3834 13.8294C10.2903 13.92 10.2037 14.0024 10.125 14.0761C10.0463 14.0024 9.95969 13.92 9.86656 13.8294C9.41381 13.3893 8.81131 12.7615 8.21065 12.0106C6.98283 10.4759 5.875 8.56484 5.875 6.75C5.875 4.32512 7.76908 2.5 10.125 2.5C12.4809 2.5 14.375 4.32512 14.375 6.75C14.375 8.56484 13.2672 10.4759 12.0393 12.0106C11.4387 12.7615 10.8362 13.3893 10.3834 13.8294ZM5.125 13.5L3.24999 18H17L15.125 13.5H12.7549C12.0974 14.272 10.8992 15.4065 10.125 16.0596C9.35081 15.4065 8.15258 14.272 7.49507 13.5H5.125Z"
      fill="currentColor"
    />
  </SvgIcon>
);

export const Testimonial = () => (
  <SvgIcon viewBox="0 0 19 15" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M0 14.179V10.1222C0 8.95549 0.21875 7.74243 0.65625 6.48296C1.10701 5.21023 1.71686 4.01042 2.4858 2.88352C3.26799 1.74337 4.14299 0.782199 5.1108 0L8.4517 2.16761C7.66951 3.34754 7.01326 4.58049 6.48295 5.86648C5.96591 7.13921 5.71402 8.54451 5.72727 10.0824V14.179H0ZM10.0824 14.179V10.1222C10.0824 8.95549 10.3011 7.74243 10.7386 6.48296C11.1894 5.21023 11.7992 4.01042 12.5682 2.88352C13.3504 1.74337 14.2254 0.782199 15.1932 0L18.5341 2.16761C17.7519 3.34754 17.0956 4.58049 16.5653 5.86648C16.0483 7.13921 15.7964 8.54451 15.8097 10.0824V14.179H10.0824Z"
      fill="#13130C"
    />
  </SvgIcon>
);

export const CloudIcon = () => (
  <SvgIcon viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M15.8333 9.16682C16.7174 9.16682 17.5652 9.51801 18.1904 10.1431C18.8155 10.7683 19.1667 11.6161 19.1667 12.5002C19.1667 13.3842 18.8155 14.2321 18.1904 14.8572C17.5652 15.4823 16.7174 15.8335 15.8333 15.8335H5C3.91662 15.8368 2.87455 15.418 2.09475 14.6659C1.31495 13.9139 0.858743 12.8876 0.822867 11.8048C0.786991 10.722 1.17427 9.66785 1.90257 8.86579C2.63088 8.06374 3.64294 7.5769 4.72417 7.50849C5.26 6.37512 6.14662 5.44446 7.25271 4.85434C8.3588 4.26423 9.62553 4.04605 10.8653 4.23211C12.1051 4.41817 13.252 4.99858 14.1361 5.88737C15.0202 6.77617 15.5946 7.92609 15.7742 9.16682H15.8333Z"
      stroke="white"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
  </SvgIcon>
);

export const WiFiIcon = () => (
  <SvgIcon viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M10 16.2582L10.0083 16.2489M1.66667 6.6665C6.66667 2.9165 13.3333 2.9165 18.3333 6.6665M4.16667 9.99984C7.5 7.49984 12.5 7.49984 15.8333 9.99984M7.08333 12.9165C8.95867 11.7498 11.0415 11.7495 12.9168 12.9165"
      fill="none"
      stroke="white"
      strokeWidth="1.575"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </SvgIcon>
);

export const AlertNotificationIcon = () => (
  <SvgIcon viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M10 5.83333V7.5M10 10.8417L10.0083 10.8324M2.5 16.9079V4.16667C2.5 3.24619 3.24619 2.5 4.16667 2.5H15.8333C16.7538 2.5 17.5 3.24619 17.5 4.16667V12.5C17.5 13.4205 16.7538 14.1667 15.8333 14.1667H6.63437C6.12807 14.1667 5.64922 14.3968 5.33292 14.7922L3.39043 17.2203C3.09518 17.5893 2.5 17.3806 2.5 16.9079Z"
      fill="none"
      stroke="white"
      strokeWidth="1.575"
      strokeLinecap="round"
    />
  </SvgIcon>
);

export const DashboardIcon = props => (
  <SvgIcon
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M2.5 7.83333V3C2.5 2.72386 2.72386 2.5 3 2.5H17C17.2762 2.5 17.5 2.72386 17.5 3V7.83333C17.5 8.10947 17.2762 8.33333 17 8.33333H3C2.72386 8.33333 2.5 8.10947 2.5 7.83333Z"
      fill="none"
      stroke="white"
      strokeWidth="1.575"
    />
    <path
      d="M11.6667 17V12.1667C11.6667 11.8905 11.8905 11.6667 12.1667 11.6667H17C17.2762 11.6667 17.5 11.8905 17.5 12.1667V17C17.5 17.2762 17.2762 17.5 17 17.5H12.1667C11.8905 17.5 11.6667 17.2762 11.6667 17Z"
      fill="none"
      stroke="white"
      strokeWidth="1.575"
    />
    <path
      d="M2.5 17V12.1667C2.5 11.8905 2.72386 11.6667 3 11.6667H7.83333C8.10947 11.6667 8.33333 11.8905 8.33333 12.1667V17C8.33333 17.2762 8.10947 17.5 7.83333 17.5H3C2.72386 17.5 2.5 17.2762 2.5 17Z"
      fill="none"
      stroke="white"
      strokeWidth="1.575"
    />
  </SvgIcon>
);

export const DirectionIcon = () => (
  <SvgIcon viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M14.4 2.6001V16.3501M14.4 16.3501L17.55 13.2001M14.4 16.3501L11.25 13.2001M5.65 16.3501V2.6001M5.65 2.6001L8.8 5.7501M5.65 2.6001L2.5 5.7501"
      stroke="white"
      strokeWidth="1.5"
    />
  </SvgIcon>
);

export const TransparentDirectionIcon = props => (
  <SvgIcon
    viewBox="0 0 146 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g filter="url(#filter0_b_961_9272)">
      <path
        d="M145.53 6.53033C145.823 6.23744 145.823 5.76256 145.53 5.46967L140.757 0.696699C140.464 0.403806 139.99 0.403806 139.697 0.696699C139.404 0.989593 139.404 1.46447 139.697 1.75736L143.939 6L139.697 10.2426C139.404 10.5355 139.404 11.0104 139.697 11.3033C139.99 11.5962 140.464 11.5962 140.757 11.3033L145.53 6.53033ZM145 5.25H1V6.75H145V5.25Z"
        fill="url(#paint0_linear_961_9272)"
      />
    </g>
    <g filter="url(#filter1_b_961_9272)">
      <path
        d="M0.46967 17.4697C0.176777 17.7626 0.176777 18.2374 0.46967 18.5303L5.24264 23.3033C5.53553 23.5962 6.01041 23.5962 6.3033 23.3033C6.59619 23.0104 6.59619 22.5355 6.3033 22.2426L2.06066 18L6.3033 13.7574C6.59619 13.4645 6.59619 12.9896 6.3033 12.6967C6.01041 12.4038 5.53553 12.4038 5.24264 12.6967L0.46967 17.4697ZM1 18.75H2V17.25H1V18.75ZM4 18.75H6V17.25H4V18.75ZM8 18.75H10V17.25H8V18.75ZM12 18.75H14V17.25H12V18.75ZM16 18.75H18V17.25H16V18.75ZM20 18.75H22V17.25H20V18.75ZM24 18.75H26V17.25H24V18.75ZM28 18.75H30V17.25H28V18.75ZM32 18.75H34V17.25H32V18.75ZM36 18.75H38V17.25H36V18.75ZM40 18.75H42V17.25H40V18.75ZM44 18.75H46V17.25H44V18.75ZM48 18.75H50V17.25H48V18.75ZM52 18.75H54V17.25H52V18.75ZM56 18.75H58V17.25H56V18.75ZM60 18.75H62V17.25H60V18.75ZM64 18.75H66V17.25H64V18.75ZM68 18.75H70V17.25H68V18.75ZM72 18.75H74V17.25H72V18.75ZM76 18.75H78V17.25H76V18.75ZM80 18.75H82V17.25H80V18.75ZM84 18.75H86V17.25H84V18.75ZM88 18.75H90V17.25H88V18.75ZM92 18.75H94V17.25H92V18.75ZM96 18.75H98V17.25H96V18.75ZM100 18.75H102V17.25H100V18.75ZM104 18.75H106V17.25H104V18.75ZM108 18.75H110V17.25H108V18.75ZM112 18.75H114V17.25H112V18.75ZM116 18.75H118V17.25H116V18.75ZM120 18.75H122V17.25H120V18.75ZM124 18.75H126V17.25H124V18.75ZM128 18.75H130V17.25H128V18.75ZM132 18.75H134V17.25H132V18.75ZM136 18.75H138V17.25H136V18.75ZM140 18.75H142V17.25H140V18.75ZM144 18.75H145V17.25H144V18.75Z"
        fill="url(#paint1_linear_961_9272)"
      />
    </g>
    <defs>
      <filter
        id="filter0_b_961_9272"
        x="-9"
        y="-9.52295"
        width="164.75"
        height="31.0459"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feGaussianBlur in="BackgroundImageFix" stdDeviation="5" />
        <feComposite
          in2="SourceAlpha"
          operator="in"
          result="effect1_backgroundBlur_961_9272"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_backgroundBlur_961_9272"
          result="shape"
        />
      </filter>
      <filter
        id="filter1_b_961_9272"
        x="-9.75"
        y="2.47705"
        width="164.75"
        height="31.0459"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feGaussianBlur in="BackgroundImageFix" stdDeviation="5" />
        <feComposite
          in2="SourceAlpha"
          operator="in"
          result="effect1_backgroundBlur_961_9272"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_backgroundBlur_961_9272"
          result="shape"
        />
      </filter>
      <linearGradient
        id="paint0_linear_961_9272"
        x1="1"
        y1="6.99989"
        x2="145"
        y2="6.99989"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#8E8E8E" stopOpacity="0" />
        <stop offset="1" stopColor="#8E8E8E" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_961_9272"
        x1="1"
        y1="18.9999"
        x2="145"
        y2="18.9999"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#8E8E8E" />
        <stop offset="1" stopColor="#8E8E8E" stopOpacity="0" />
      </linearGradient>
    </defs>
  </SvgIcon>
);

export const HotIcon = props => (
  <SvgIcon
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.85076 5.85076C6.9291 4.77243 8.39163 4.16663 9.91663 4.16663C11.4416 4.16663 12.9042 4.77243 13.9825 5.85076C15.0608 6.9291 15.6666 8.39163 15.6666 9.91663C15.6666 11.4416 15.0608 12.9042 13.9825 13.9825C12.9042 15.0608 11.4416 15.6666 9.91663 15.6666C8.39163 15.6666 6.9291 15.0608 5.85076 13.9825C4.77243 12.9042 4.16663 11.4416 4.16663 9.91663C4.16663 8.39163 4.77243 6.9291 5.85076 5.85076ZM9.91663 5.66663C8.78946 5.66663 7.70845 6.11439 6.91142 6.91142C6.11439 7.70845 5.66663 8.78946 5.66663 9.91663C5.66663 11.0438 6.11439 12.1248 6.91142 12.9218C7.70845 13.7189 8.78946 14.1666 9.91663 14.1666C11.0438 14.1666 12.1248 13.7189 12.9218 12.9218C13.7189 12.1248 14.1666 11.0438 14.1666 9.91663C14.1666 8.78946 13.7189 7.70845 12.9218 6.91142C12.1248 6.11439 11.0438 5.66663 9.91663 5.66663Z"
      fill="currentColor"
    />
    <path d="M10.6666 1V3H9.16663V1H10.6666Z" fill="currentColor" />
    <path d="M10.6666 17V19H9.16663V17H10.6666Z" fill="currentColor" />
    <path d="M18.9166 10.75H16.9166V9.25H18.9166V10.75Z" fill="currentColor" />
    <path d="M2.91663 10.75H0.916626V9.25H2.91663V10.75Z" fill="currentColor" />
    <path
      d="M4.08289 3.10571L5.4971 4.51992L4.43644 5.58058L3.02223 4.16637L4.08289 3.10571Z"
      fill="currentColor"
    />
    <path
      d="M15.3966 14.4194L16.8108 15.8336L15.7502 16.8943L14.3359 15.4801L15.3966 14.4194Z"
      fill="currentColor"
    />
    <path
      d="M16.8108 4.16637L15.3966 5.58058L14.3359 4.51992L15.7502 3.10571L16.8108 4.16637Z"
      fill="currentColor"
    />
    <path
      d="M5.4971 15.4801L4.08289 16.8943L3.02223 15.8336L4.43644 14.4194L5.4971 15.4801Z"
      fill="currentColor"
    />
  </SvgIcon>
);

export const ColdIcon = props => (
  <SvgIcon
    {...props}
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.7623 1V2.5036L11.8342 2.04793L12.4004 3.55207L10.7623 4.2484V8.63552L13.9574 6.78339L14.3268 4.03545L15.8359 4.26455L15.6328 5.77504L17.2438 4.79672L18.0001 6.20328L16.6069 7.04936L17.8314 7.42117L17.4126 8.97883L14.7488 8.17L11.5918 10L14.7488 11.83L17.4126 11.0212L17.8314 12.5788L16.6069 12.9506L18.0001 13.7967L17.2438 15.2033L15.6328 14.225L15.8359 15.7354L14.3268 15.9646L13.9574 13.2166L10.7623 11.3645V15.3914L12.5094 16.5054L11.7252 17.8946L10.7623 17.2806V19H9.23794V17.2806L8.27508 17.8946L7.4908 16.5054L9.23794 15.3914V11.3645L6.0428 13.2166L5.67341 15.9646L4.16436 15.7354L4.36741 14.225L2.75642 15.2033L2.00012 13.7967L3.39337 12.9506L2.16888 12.5788L2.58766 11.0212L5.25148 11.83L8.40843 10L5.25148 8.17L2.58766 8.97883L2.16888 7.42117L3.39337 7.04936L2.00012 6.20328L2.75642 4.79672L4.36741 5.77504L4.16436 4.26455L5.67341 4.03545L6.0428 6.78339L9.23794 8.63552V4.2484L7.59987 3.55207L8.16601 2.04793L9.23794 2.5036V1H10.7623Z"
      fill="currentColor"
    />
  </SvgIcon>
);

export const WindIcon = props => (
  <SvgIcon
    {...props}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.67667 2.58325C10.2582 2.58325 11.5833 3.82839 11.5833 5.41659C11.5833 7.00496 10.2571 8.24992 8.67667 8.24992H2.5V6.74992H8.67667C9.47787 6.74992 10.0833 6.12821 10.0833 5.41659C10.0833 4.70478 9.47851 4.08325 8.67667 4.08325V2.58325ZM15.2325 5.08325C16.8383 5.08325 18.25 6.294 18.25 7.91658C18.25 9.53917 16.8383 10.7499 15.2325 10.7499H2.5V9.24992H15.2325C16.1317 9.24992 16.75 8.594 16.75 7.91658C16.75 7.23917 16.1317 6.58325 15.2325 6.58325V5.08325ZM2.5 11.7499H14.9475C15.513 11.7499 16.2297 11.871 16.8227 12.3173C17.4529 12.7917 17.8333 13.55 17.8333 14.5833C17.8333 15.6165 17.4529 16.3748 16.8229 16.8491C16.23 17.2954 15.5136 17.4166 14.9483 17.4166V15.9166C15.3323 15.9166 15.6833 15.8294 15.9207 15.6507C16.1208 15.5001 16.3333 15.2166 16.3333 14.5833C16.3333 13.9499 16.1208 13.6665 15.9207 13.5158C15.6832 13.3371 15.332 13.2499 14.9475 13.2499H2.5V11.7499Z"
      fill="currentColor"
    />
  </SvgIcon>
);

export const RainIcon = props => (
  <SvgIcon
    {...props}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.98187 3.15588C5.77938 1.8267 7.31735 0.916748 9.99999 0.916748C12.6826 0.916748 14.2206 1.8267 15.0181 3.15588C15.5837 4.0985 15.7124 5.16356 15.7415 5.97511C16.458 6.08361 17.2984 6.35567 18.0425 6.89144C19.1037 7.6555 19.9167 8.92234 19.9167 10.8334C19.9167 12.1028 19.5579 13.1033 18.9811 13.8638C18.4102 14.6163 17.6601 15.089 16.9401 15.371L16.3932 13.9742C16.9182 13.7686 17.4181 13.4422 17.786 12.9572C18.1479 12.4802 18.4167 11.8049 18.4167 10.8334C18.4167 9.41116 17.8409 8.59466 17.166 8.10872C16.4529 7.59525 15.5746 7.41675 15 7.41675C14.5858 7.41675 14.25 7.08096 14.25 6.66675C14.25 5.80577 14.2345 4.76528 13.7319 3.92762C13.2794 3.17346 12.3174 2.41675 9.99999 2.41675C7.68264 2.41675 6.72061 3.17346 6.26811 3.92762C5.76552 4.76528 5.74999 5.80577 5.74999 6.66675C5.74999 7.08096 5.41421 7.41675 4.99999 7.41675C4.42541 7.41675 3.54709 7.59525 2.83396 8.10872C2.15908 8.59466 1.58333 9.41116 1.58333 10.8334C1.58333 11.8049 1.85209 12.4802 2.21398 12.9572C2.58188 13.4422 3.0818 13.7686 3.60679 13.9742L3.05987 15.371C2.33986 15.089 1.58977 14.6163 1.01892 13.8638C0.442067 13.1033 0.0833282 12.1028 0.0833282 10.8334C0.0833282 8.92234 0.896328 7.6555 1.95748 6.89144C2.70157 6.35567 3.54202 6.08361 4.25845 5.97511C4.2876 5.16356 4.4163 4.0985 4.98187 3.15588ZM10.75 11.5001V14.5001H9.24999V11.5001H10.75ZM7.41666 15.0001V18.0001H5.91666V15.0001H7.41666ZM14.0833 15.0001V18.0001H12.5833V15.0001H14.0833ZM10.75 16.0001V19.0001H9.24999V16.0001H10.75Z"
      fill="currentColor"
    />
  </SvgIcon>
);
